import React, { useState, useEffect } from "react";
import "./Calculation.css";
// import Spinner from "../../components/spinner/Spinner";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

function Calculation() {
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [exitPercentage, setExitPercentage] = useState("");
  const [minOfferPercentage, setMinOfferPercentage] = useState("");
  const [profit, setProfit] = useState("");
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    loadCalculation();
  }, []);

  const loadCalculation = async () => {
    try {
      // setLoading(true);
      const URL = `${process.env.REACT_APP_BASE_URL}api/get-offer-calculation`;
      const { data } = await axios.post(URL);
      if (data?.prices) setPrices(data.prices);
    } catch (err) {
      setError(err);
      toast.error("Failed to load calculations");
    } finally {
      // setLoading(false);
    }
  };

  const validateInputs = () => {
    const min = Number(minPrice);
    const max = Number(maxPrice);
    const exit = Number(exitPercentage);
    const profitValue = Number(profit);
    const minOffer = minOfferPercentage !== "" ? Number(minOfferPercentage) : null;

    if (isNaN(min) || isNaN(max)) {
      toast.error("Minimum and Maximum price are required");
      return false;
    }

    if (min < 0 || max < 0) {
      toast.error("Prices cannot be negative");
      return false;
    }

    if (max <= min) {
      toast.error("Maximum price must be greater than minimum price");
      return false;
    }

    if (exit < 0 || exit > 100) {
      toast.error("Exit percentage must be between 0 and 100");
      return false;
    }

    if (minOffer !== null && (minOffer < 0 || minOffer > 100)) {
      toast.error("Min offer percentage must be between 0 and 100");
      return false;
    }

    if (profitValue < 0) {
      toast.error("Profit cannot be negative");
      return false;
    }

    const overlap = prices.some((p) => {
      return min <= p.to_price && max >= p.from_price;
    });

    if (overlap) {
      toast.error("Price range overlaps with an existing range");
      return false;
    }

    return true;
  };

  const addPrices = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    try {
      const URL = `${process.env.REACT_APP_BASE_URL}api/save-new-offer-prices`;

      const { data } = await axiosInstance.post(URL, {
        min: Number(minPrice),
        max: Number(maxPrice),
        exit: Number(exitPercentage),
        profit: Number(profit),
        minOfferPercentage: minOfferPercentage === "" ? null : Number(minOfferPercentage),
      });

      if (data.success) {
        toast.success("Offer calculation added successfully");
        setMinPrice("");
        setMaxPrice("");
        setExitPercentage("");
        setMinOfferPercentage("");
        setProfit("");
        loadCalculation();
      } else {
        toast.error(data.error || "Failed to add offer calculation");
      }
    } catch (err) {
      toast.error("Server error while adding calculation");
    }
  };

  const deleteOffer = async (id) => {
    try {
      const URL = `${process.env.REACT_APP_BASE_URL}api/delete-offer-calculation`;
      const { data } = await axiosInstance.post(URL, { id });

      if (data.success) {
        toast.success("Offer calculation deleted");
        loadCalculation();
      } else {
        toast.error(data.error || "Failed to delete record");
      }
    } catch (err) {
      toast.error("Server error while deleting calculation");
    }
  };

  const formatNumber = (value) => Number(value).toLocaleString("en-US");

  // if (loading) return <Spinner />;

  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <table id="dataTable" className="w-full text-sm rounded-lg">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th>Minimum Price</th>
            <th>Maximum Price</th>
            <th>Exit Percentage</th>
            <th>Profit</th>
            <th>Min Offer Percentage</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {prices.map((res) => (
            <tr className="hover:bg-gray-50 transition" key={res.id}>
              <td>$ {formatNumber(res.from_price)}</td>
              <td>$ {formatNumber(res.to_price)}</td>
              <td>{res.exit_percentage} %</td>
              <td>$ {formatNumber(res.profit)}</td>
              <td>{res.min_offer_percentage} %</td>
              <td>
                <button className="delete_button shadow" onClick={() => deleteOffer(res.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <form onSubmit={addPrices} className="grid grid-cols-2 !gap-4 max-w-3xl !pl-6">
        <label className="grid grid-cols-2 text-left text-nowrap" htmlFor="minPrice">
          <span>Min Price :</span>
          <input type="number" name="minPrice" className="calc_price_input !w-full" value={minPrice} onChange={(e) => setMinPrice(e.target.value)} placeholder="Minimum Price" />
        </label>
        <label className="grid grid-cols-2 text-left text-nowrap" htmlFor="maxPrice">
          <span>Max Price :</span>
          <input type="number" className="calc_price_input !w-full" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} placeholder="Maximum Price" />
        </label>

        <label className="grid grid-cols-2 text-left text-nowrap" htmlFor="exitPercentage">
          <span>Exit Percentage :</span>
          <input type="number" className="calc_price_input !w-full" value={exitPercentage} onChange={(e) => setExitPercentage(e.target.value)} placeholder="Exit Percentage" />
        </label>
        <label className="grid grid-cols-2 text-left text-nowrap" htmlFor="profit">
          <span>Profit :</span>
          <input type="number" className="calc_price_input !w-full" value={profit} onChange={(e) => setProfit(e.target.value)} placeholder="Profit" />
        </label>
        <label className="grid grid-cols-2 text-left text-nowrap" htmlFor="minOfferPercentage">
          <span>Min Offer Percentage :</span>
          <input type="number" className="calc_price_input !w-full" value={minOfferPercentage} onChange={(e) => setMinOfferPercentage(e.target.value)} placeholder="Min Offer Percentage" />
        </label>
        <div className="flex justify-center item-center w-full col-span-2">
          <button className="calc_add_btn !w-full max-w-42 shadow" type="submit">
            Add
          </button>
        </div>
      </form>
    </div>
  );
}

export default Calculation;
